
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("j7llE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "GenerationPresetsPage", function () { return $206604056ab487cb$export$bd7afd383c03b1f4; });
$parcel$export(module.exports, "default", function () { return $206604056ab487cb$export$2e2bcd8739ae039; });

var $9mEBw = parcelRequire("9mEBw");

var $8CMwS = parcelRequire("8CMwS");

var $cE6td = parcelRequire("cE6td");
var $awX35 = parcelRequire("awX35");

var $ehn1v = parcelRequire("ehn1v");

var $6mGiZ = parcelRequire("6mGiZ");
var $1SCdZ = parcelRequire("1SCdZ");
var $eDHCR = parcelRequire("eDHCR");
var $a92Pv = parcelRequire("a92Pv");

var $cE6td = parcelRequire("cE6td");

var $5EZ3C = parcelRequire("5EZ3C");

var $2GdZx = parcelRequire("2GdZx");

var $lVT52 = parcelRequire("lVT52");

var $4ixDw = parcelRequire("4ixDw");

var $kae71 = parcelRequire("kae71");

var $5xVcr = parcelRequire("5xVcr");

var $8Z000 = parcelRequire("8Z000");

var $fQuwG = parcelRequire("fQuwG");

var $9syzB = parcelRequire("9syzB");

var $h5ngh = parcelRequire("h5ngh");

var $3dX86 = parcelRequire("3dX86");

var $fxtOB = parcelRequire("fxtOB");

var $5P4TK = parcelRequire("5P4TK");

var $ed8Wt = parcelRequire("ed8Wt");
var $206604056ab487cb$var$_tmpl$ = /*#__PURE__*/ (0, $awX35.template)(`<div class="flex flex-row justify-end">`), $206604056ab487cb$var$_tmpl$2 = /*#__PURE__*/ (0, $awX35.template)(`<div class="flex flex-col gap-2 pb-10"><div class="flex flex-col gap-4 p-2"><form class="flex flex-col gap-4"><div class="flex gap-4"></div><div class="flex flex-col"><div>ID: `), $206604056ab487cb$var$_tmpl$3 = /*#__PURE__*/ (0, $awX35.template)(`<form>`);
const $206604056ab487cb$export$bd7afd383c03b1f4 = ()=>{
    const { updateTitle: updateTitle } = (0, $8Z000.setComponentPageTitle)('Preset');
    const params = (0, $ehn1v.useParams)();
    const [query] = (0, $ehn1v.useSearchParams)();
    const nav = (0, $ehn1v.useNavigate)();
    const [selecting, setSelecting] = (0, $cE6td.createSignal)(false);
    const [deleting, setDeleting] = (0, $cE6td.createSignal)(false);
    const [store, setters] = (0, $ed8Wt.usePresetContext)({
        anonymous: true
    });
    const onEdit = (preset)=>{
        nav(`/presets/${preset._id}`);
    };
    const presets = (0, $fQuwG.presetStore)(({ presets: presets, saving: saving, importing: importing })=>({
            saving: saving,
            presets: presets,
            items: presets.map((p)=>({
                    label: p.name,
                    value: p._id
                })),
            importing: importing,
            editing: (0, $5EZ3C.isDefaultPreset)(query.preset) ? (0, $5EZ3C.defaultPresets)[query.preset] : presets.find((pre)=>pre._id === query.preset || params.id)
        }));
    (0, $cE6td.onMount)(async ()=>{
        if (params.id === 'new') {
            const copySource = query.preset;
            if (copySource) updateTitle(`Copy preset ${copySource}`);
            else if (presets.importing) updateTitle(`Import preset`);
            else updateTitle(`Create preset`);
            if (presets.importing) {
                setters.setState((0, $8CMwS._)((0, $9mEBw._)({}, presets.importing), {
                    _id: '',
                    name: presets.importing.name ? `${presets.importing.name} - Imported` : 'Imported Preset'
                }));
                (0, $fQuwG.presetStore).setImportPreset();
                return;
            }
            const template = (0, $5EZ3C.isDefaultPreset)(query.preset) ? (0, $5EZ3C.defaultPresets)[query.preset] : presets.presets.find((p)=>p._id === query.preset);
            const preset = template ? (0, $9mEBw._)({}, template) : (0, $9mEBw._)({}, $206604056ab487cb$var$emptyPreset);
            setters.setState((0, $8CMwS._)((0, $9mEBw._)({}, $206604056ab487cb$var$emptyPreset, preset), {
                _id: ''
            }));
            return;
        } else if (params.id === 'default') {
            if (!(0, $5EZ3C.isDefaultPreset)(query.preset)) return;
            setters.setState((0, $8CMwS._)((0, $9mEBw._)({}, $206604056ab487cb$var$emptyPreset, (0, $5EZ3C.defaultPresets)[query.preset]), {
                _id: '',
                userId: 'SYSTEM'
            }));
            return;
        }
        if (params.id && store._id !== params.id) setters.load(params.id);
        // if (params.id && store._id !== params.id) {
        //   const preset = presets.presets.find((p) => p._id === params.id)
        //   setStore(preset!)
        // }
        if (params.id && store) updateTitle(`Edit preset ${store.name}`);
    });
    const startNew = ()=>{
        nav('/presets/new');
    };
    const deletePreset = ()=>{
        (0, $fQuwG.presetStore).deletePreset(store._id, ()=>nav('/presets'));
        setters.setState($206604056ab487cb$var$emptyPreset);
    };
    const onSave = (ev)=>{
        ev === null || ev === void 0 ? void 0 : ev.preventDefault();
        if (presets.saving) return;
        setters.upsert({
            onCreated: (newPreset)=>{
                nav(`/presets/${newPreset._id}`);
                setters.setState(newPreset);
            }
        });
    };
    if (params.id && params.id !== 'new' && !presets.editing) return (0, $cE6td.createComponent)((0, $3dX86.Page), {
        get children () {
            return [
                (0, $cE6td.createComponent)((0, $kae71.default), {
                    title: "Generation Presets"
                }),
                (0, $cE6td.createComponent)((0, $9syzB.default), {})
            ];
        }
    });
    return (0, $cE6td.createComponent)((0, $3dX86.Page), {
        get children () {
            return [
                (0, $cE6td.createComponent)((0, $kae71.default), {
                    title: "Generation Presets"
                }),
                (()=>{
                    var _el$ = $206604056ab487cb$var$_tmpl$2(), _el$2 = _el$.firstChild, _el$3 = _el$2.firstChild, _el$4 = _el$3.firstChild, _el$5 = _el$4.nextSibling, _el$6 = _el$5.firstChild, _el$7 = _el$6.firstChild;
                    (0, $awX35.insert)(_el$, (0, $cE6td.createComponent)((0, $cE6td.Show), {
                        get when () {
                            return params.id === 'default';
                        },
                        get children () {
                            return (0, $cE6td.createComponent)((0, $h5ngh.TitleCard), {
                                type: "orange",
                                "class": "font-bold",
                                get children () {
                                    return [
                                        "This is a built-in preset and cannot be saved.",
                                        ' ',
                                        (0, $cE6td.createComponent)((0, $ehn1v.A), {
                                            "class": "link",
                                            get href () {
                                                return `/presets/new?preset=${query.preset}`;
                                            },
                                            children: "Click here"
                                        }),
                                        ' ',
                                        "if you'd like to create a copy of this preset."
                                    ];
                                }
                            });
                        }
                    }), _el$2);
                    _el$3.addEventListener("submit", onSave);
                    (0, $awX35.insert)(_el$4, (0, $cE6td.createComponent)((0, $cE6td.Show), {
                        get when () {
                            return presets.presets.length > 1;
                        },
                        get children () {
                            return (0, $cE6td.createComponent)((0, $2GdZx.default), {
                                onClick: ()=>setSelecting(true),
                                children: "Load Preset"
                            });
                        }
                    }), null);
                    (0, $awX35.insert)(_el$4, (0, $cE6td.createComponent)((0, $2GdZx.default), {
                        onClick: startNew,
                        get children () {
                            return [
                                (0, $cE6td.createComponent)((0, $1SCdZ.default), {}),
                                "New Preset"
                            ];
                        }
                    }), null);
                    (0, $awX35.insert)(_el$6, ()=>store._id || 'New Preset', null);
                    (0, $awX35.insert)(_el$5, (0, $cE6td.createComponent)((0, $5xVcr.default), {
                        fieldName: "id",
                        get value () {
                            return store._id || 'New Preset';
                        },
                        disabled: true,
                        "class": "hidden"
                    }), null);
                    (0, $awX35.insert)(_el$5, (0, $cE6td.createComponent)((0, $5xVcr.default), {
                        label: "Name",
                        helperText: "A name or short description of your preset",
                        placeholder: "Preset name",
                        get value () {
                            return store.name;
                        },
                        onChange: (ev)=>setters.setState('name', ev.currentTarget.value),
                        required: true,
                        parentClass: "mb-2"
                    }), null);
                    (0, $awX35.insert)(_el$5, (0, $cE6td.createComponent)((0, $fxtOB.default), {
                        state: store,
                        setters: setters,
                        noSave: true
                    }), null);
                    (0, $awX35.insert)(_el$3, (0, $cE6td.createComponent)((0, $cE6td.Show), {
                        get when () {
                            return store.userId !== 'SYSTEM';
                        },
                        get children () {
                            var _el$8 = $206604056ab487cb$var$_tmpl$();
                            (0, $awX35.insert)(_el$8, (0, $cE6td.createComponent)((0, $2GdZx.default), {
                                get disabled () {
                                    return presets.saving;
                                },
                                onClick: onSave,
                                get children () {
                                    return [
                                        (0, $cE6td.createComponent)((0, $eDHCR.default), {}),
                                        " Save"
                                    ];
                                }
                            }));
                            return _el$8;
                        }
                    }), null);
                    return _el$;
                })(),
                (0, $cE6td.createComponent)($206604056ab487cb$var$EditPreset, {
                    get show () {
                        return selecting();
                    },
                    close: ()=>setSelecting(false),
                    select: onEdit
                }),
                (0, $cE6td.createComponent)((0, $4ixDw.ConfirmModal), {
                    get show () {
                        return deleting();
                    },
                    close: ()=>setDeleting(false),
                    confirm: deletePreset,
                    message: "Are you sure you wish to delete this preset?"
                })
            ];
        }
    });
};
var $206604056ab487cb$export$2e2bcd8739ae039 = $206604056ab487cb$export$bd7afd383c03b1f4;
const $206604056ab487cb$var$emptyPreset = (0, $8CMwS._)((0, $9mEBw._)({}, (0, $5EZ3C.presetDefaults)), {
    gaslight: (0, $5P4TK.templates).Universal,
    service: '',
    name: '',
    maxTokens: 300
});
const $206604056ab487cb$var$EditPreset = (props)=>{
    var _state_presets_;
    const params = (0, $ehn1v.useParams)();
    const state = (0, $fQuwG.presetStore)((s)=>({
            presets: s.presets
        }));
    const select = ()=>{
        const preset = state.presets.find((preset)=>preset._id === id());
        props.select(preset);
        props.close();
    };
    const [id, setId] = (0, $cE6td.createSignal)((_state_presets_ = state.presets[0]) === null || _state_presets_ === void 0 ? void 0 : _state_presets_._id);
    return (0, $cE6td.createComponent)((0, $4ixDw.default), {
        get show () {
            return props.show;
        },
        get close () {
            return props.close;
        },
        title: "Load Preset",
        get footer () {
            return [
                (0, $cE6td.createComponent)((0, $2GdZx.default), {
                    schema: "secondary",
                    get onClick () {
                        return props.close;
                    },
                    get children () {
                        return [
                            (0, $cE6td.createComponent)((0, $a92Pv.default), {}),
                            " Cancel"
                        ];
                    }
                }),
                (0, $cE6td.createComponent)((0, $2GdZx.default), {
                    onClick: select,
                    get children () {
                        return [
                            (0, $cE6td.createComponent)((0, $6mGiZ.default), {}),
                            " Load Preset"
                        ];
                    }
                })
            ];
        },
        get children () {
            var _el$9 = $206604056ab487cb$var$_tmpl$3();
            (0, $awX35.insert)(_el$9, (0, $cE6td.createComponent)((0, $lVT52.default), {
                label: "Preset",
                helperText: "Select a preset to start editing. If you are currently editing a preset, it won't be in the list.",
                get items () {
                    return state.presets.filter((pre)=>pre._id !== params.id).map((pre)=>({
                            label: pre.name,
                            value: pre._id
                        }));
                },
                onChange: (ev)=>setId(ev.value)
            }));
            return _el$9;
        }
    });
};

});


//# sourceMappingURL=GenerationPresets.a735a781.js.map
